<div class="recipeGrid">
	<ul
		#recipeList
		[ngClass]="{
			'recipeGrid-list': true,
			'recipeGrid-list--carousel': mode === 'carousel'
		}"
	>
		<li *ngFor="let stamp of recipeStampList; let i = index; trackBy: trackByFn">
			<recipe-stamp
				[stamp]="stamp"
				[stampType]="stampType"
				[initialServings]="initialServings"
				[cdxTrackImpression]="recipeImpressionArgs[i]"
				[@opacity]
				(save)="saveRecipe.emit({ recipeId: stamp.recipe.id, isSaved: stamp.recipe.saved })"
				(addServing)="addServing.emit($event)"
				(removeServing)="removeServing.emit($event)"
				(stampClick)="stampClick.emit({ recipe: stamp.recipe, slot: i })"
			></recipe-stamp>
		</li>
	</ul>
</div>
